var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24X24Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3699A1DE-241C-4022-BEB4-02E1AB5CE83A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "style-guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide-v1.0",
    transform: "translate(-697.000000, -2092.000000)",
    fill: "#D83838",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Calendar-Copy-23",
    transform: "translate(697.000000, 2092.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8941772,1.86304511 C13.281232,2.05657251 13.595077,2.3704175 13.7886044,2.7574723 L21.9626547,19.1055728 C22.4566332,20.0935298 22.0561845,21.2948759 21.0682275,21.7888544 C20.7905166,21.9277098 20.4842905,22 20.1738003,22 L3.8256998,22 C2.7211303,22 1.8256998,21.1045695 1.8256998,20 C1.8256998,19.6895098 1.89798998,19.3832837 2.03684542,19.1055728 L10.2108957,2.7574723 C10.7048742,1.76951531 11.9062203,1.36906662 12.8941772,1.86304511 Z M12.2176837,17.2579545 C11.4349495,17.2579545 10.8359182,17.8330245 10.8359182,18.5838104 C10.8359182,19.3345963 11.4349495,19.9096664 12.2176837,19.9096664 C13.000418,19.9096664 13.5994493,19.3345963 13.5994493,18.5838104 C13.5994493,17.8330245 13.000418,17.2579545 12.2176837,17.2579545 Z M13.3518497,8.53605866 L11.0835178,8.53605866 L11.4030011,16.3713881 L13.0323663,16.3713881 L13.3518497,8.53605866 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24X24Error);
export default __webpack_public_path__ + "static/media/icon-24x24-error.90f37f92241b5e6d91b7aa9cd61edd7b.svg";
export { ForwardRef as ReactComponent };